(function () {
  document.querySelectorAll('[data-isl-track]').forEach(function (track) {
    var viewport = track.closest('[data-isl-viewport]');
    var wrap = track.closest('.isl__wrap');
    var prevBtn = wrap.querySelector('[data-isl-prev]');
    var nextBtn = wrap.querySelector('[data-isl-next]');
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var index = 0;
    var autoplay = viewport.dataset.autoplay === 'true';
    var speed = parseFloat(viewport.dataset.speed) * 1000 || 3500;
    var timer = null;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    function perView() {
      return window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function goTo(i) {
      index = Math.max(0, Math.min(i, maxIndex()));
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.style.transform = 'translateX(-' + (index * (slideWidth + gap)) + 'px)';
    }

    function next() {
      if (index >= maxIndex()) {
        goTo(0);
      } else {
        goTo(index + 1);
      }
    }

    function prev() {
      if (index <= 0) {
        goTo(maxIndex());
      } else {
        goTo(index - 1);
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay) return;
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });

    viewport.addEventListener('mouseenter', stopAutoplay);
    viewport.addEventListener('mouseleave', startAutoplay);

    // Touch swipe support (mobile)
    var touchStartX = 0;
    var touchEndX = 0;
    viewport.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].clientX;
      var diff = touchStartX - touchEndX;
      if (diff > 40) next();
      else if (diff < -40) prev();
      startAutoplay();
    }, { passive: true });

    window.addEventListener('resize', function () {
      goTo(index);
    });

    goTo(0);
    startAutoplay();
  });
})();